import { createTheme } from "@mui/material/styles";

const adminTheme = createTheme({
  palette: {
    primary: {
      main: "#5E35B1",
      light: "#7E57C2",
      dark: "#4527A0",
      contrastText: "#fff",
    },
    secondary: {
      main: "#00ACC1",
      light: "#4DD0E1",
      dark: "#0097A7",
    },
    background: {
      default: "#F5F5F9",
      paper: "#FFFFFF",
    },
    success: { main: "#43A047" },
    warning: { main: "#FB8C00" },
    error: { main: "#E53935" },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 500,
    },
    body2: {
      color: "rgba(0,0,0,0.7)",
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    "none",
    "0px 2px 4px rgba(94, 53, 177, 0.08)",
    "0px 4px 8px rgba(94, 53, 177, 0.08)",
    "0px 8px 16px rgba(94, 53, 177, 0.08)",
    "0px 12px 24px rgba(94, 53, 177, 0.1)",
    "0px 16px 32px rgba(94, 53, 177, 0.1)",
    "0px 20px 40px rgba(94, 53, 177, 0.12)",
    "0px 24px 48px rgba(94, 53, 177, 0.12)",
    "0px 28px 56px rgba(94, 53, 177, 0.14)",
    "0px 32px 64px rgba(94, 53, 177, 0.14)",
    "0px 36px 72px rgba(94, 53, 177, 0.16)",
    "0px 40px 80px rgba(94, 53, 177, 0.16)",
    "0px 44px 88px rgba(94, 53, 177, 0.18)",
    "0px 48px 96px rgba(94, 53, 177, 0.18)",
    "0px 52px 104px rgba(94, 53, 177, 0.2)",
    "0px 56px 112px rgba(94, 53, 177, 0.2)",
    "0px 60px 120px rgba(94, 53, 177, 0.22)",
    "0px 64px 128px rgba(94, 53, 177, 0.22)",
    "0px 68px 136px rgba(94, 53, 177, 0.24)",
    "0px 72px 144px rgba(94, 53, 177, 0.24)",
    "0px 76px 152px rgba(94, 53, 177, 0.26)",
    "0px 80px 160px rgba(94, 53, 177, 0.26)",
    "0px 84px 168px rgba(94, 53, 177, 0.28)",
    "0px 88px 176px rgba(94, 53, 177, 0.28)",
    "0px 92px 184px rgba(94, 53, 177, 0.3)",
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
          padding: "8px 20px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0px 4px 12px rgba(94, 53, 177, 0.25)",
          },
        },
        contained: {
          "&:hover": {
            boxShadow: "0px 4px 12px rgba(94, 53, 177, 0.35)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0px 4px 20px rgba(94, 53, 177, 0.08)",
          border: "1px solid rgba(94, 53, 177, 0.06)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0px 2px 12px rgba(94, 53, 177, 0.15)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: "1px solid rgba(94, 53, 177, 0.08)",
          boxShadow: "2px 0 12px rgba(0,0,0,0.04)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: "2px 8px",
          "&.Mui-selected": {
            backgroundColor: "rgba(94, 53, 177, 0.12)",
            "&:hover": {
              backgroundColor: "rgba(94, 53, 177, 0.18)",
            },
            "& .MuiListItemIcon-root": {
              color: "#5E35B1",
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          backgroundColor: "rgba(94, 53, 177, 0.06)",
          color: "#5E35B1",
          borderBottom: "2px solid rgba(94, 53, 177, 0.12)",
        },
        root: {
          borderBottom: "1px solid rgba(0,0,0,0.06)",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "rgba(94, 53, 177, 0.04)",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(94, 53, 177, 0.5)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderWidth: "2px",
            },
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          boxShadow: "0px 24px 48px rgba(94, 53, 177, 0.18)",
        },
      },
    },
  },
});

export default adminTheme;
